<template>
  <div class="aboutView">
    <about />
  </div>
</template>

<script>
import about from '../../components/user/about.vue';
export default {
    name:"aboutView",
    components:{about}

}
</script>

<style>

</style>